// extracted by mini-css-extract-plugin
export default {"inputSection":"DGf2nu88xyMgQtxFPrE9"};